import React from "react";

function Certificate(props){
    return (
        <iframe src={`https://drive.google.com/file/d/${props.file}/preview`} title={ props.title } frameBorder={0}></iframe>
    );
}

export default Certificate;